import { MatDialog } from "@angular/material/dialog"
import { DialogComponent } from "../dialog/dialog.component";
import { DialogData,Survey, TIPS } from "./model-service"

export class PopupService{

    constructor(private dialog:MatDialog){}

    openPopupDialog(popupDestinationId: number, Surveys:Survey) {
        let popup = Surveys.popups.find(element => element.surveyPopupId == popupDestinationId);
        let dataDialog: DialogData = { 
            id : popup.id,
            title : popup.popupTitle,
            content : popup.popupContent,
            type : popup.type,
        }
        this.dialog.open(DialogComponent, {
            data: dataDialog,
            minWidth:'auto',
            maxWidth: '60%',
        })
    }
    openTipDialog(tipDestinationTipId : number){
        let tip = TIPS.find(element => element.id == tipDestinationTipId);
        let dataDialog : DialogData = {
            id : tip.id,
            title : tip.title,
            content : tip.content,
            url: tip.url
        }
        this.dialog.open(DialogComponent,{
            data : dataDialog,
            minWidth:'auto',
            maxWidth: '60%',
        });
        tip.patientTip.isPriority = true;

    }

}